import DownloadContactIdMappingReportRequestModelBase from '../_generated/modelBases/download-contact-id-mapping-report-request-model-base';

export default class DownloadContactIdMappingReportRequestModel extends DownloadContactIdMappingReportRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
